<div class="header-login bg-white">
  <div class="container-fluid h-100">
    <div class="row align-items-stretch h-100">
      <div
        class="col-6 gx-lg-5 d-none d-lg-flex align-items-center header-login__left"
      >
        <a [routerLink]="['']" [queryParams]="route.snapshot.queryParams">
          <img src="assets/img/nmosd-logo.svg" class="logo" alt="logo" />
        </a>
      </div>
      <div
        class="col-12 col-lg-6 gx-lg-5 d-flex align-items-center justify-content-between justify-content-lg-end fs-7"
      >
        <a
          [routerLink]="['/']"
          [queryParams]="route.snapshot.queryParams"
          class="mw-50 d-lg-none"
        >
          <img
            src="assets/img/nmosd-topbar-logo.svg"
            class="img-fluid"
            alt="logo"
          />
        </a>
        <a
          [routerLink]="['/', 'sign-up']"
          *ngIf="url === '/sign-in'"
          class="link p-0 text-uppercase fw-semi-bold"
          i18n="@@authentication_loginFormEmpty_createAccountLink"
          >Create account</a
        >
        <a
          [routerLink]="['/', 'sign-in']"
          *ngIf="url === '/password-request'"
          class="link p-0 text-uppercase fw-bold"
          i18n="@@authentication_loginFormEmpty_backLink"
          >Back to login</a
        >
      </div>
    </div>
  </div>
</div>
